"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultWebhookGameEventList = void 0;
const webhook_1 = require("../../enums/webhook");
exports.defaultWebhookGameEventList = [
    {
        type: webhook_1.WebhookGameEventType.FIRST_GAME_START,
        description: 'First Game Start',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.GAME_START,
        description: 'Game Start',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.FORM_SUBMISSION_GAME_START,
        description: 'Form Submission - StartGame',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.FORM_SUBMISSION_COMPLETED_CHALLENGE,
        description: 'Form Submission - Completed Challenge',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.CHALLENGE_COMPLETED,
        description: 'Challenge Completed',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.WINNERS_AND_PRIZES,
        description: 'Winners & Prizes',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameEventType.GAME_OVER,
        description: 'Game Over',
        isEnabled: true,
    },
];
